import { useMemo } from 'react';

const setRef = (ref, element) => {
  if (typeof ref === 'function') {
    ref(element);
  } else if (ref) {
    ref.current = element; // eslint-disable-line no-param-reassign
  }
};

function useCombinedRef(refA, refB) {
  return useMemo(() => {
    if (!refA) return refB;
    if (!refB) return refA;

    return (element) => {
      setRef(refA, element);
      setRef(refB, element);
    };
  }, [refA, refB]);
}

export default useCombinedRef;
